// @ts-nocheck
import Swiper from 'swiper/bundle';
import { updateSwiperStatus, updateSlidesInert } from '@/js/utils/accessibility-swiper';
document.addEventListener("DOMContentLoaded", function(){
	const AUTOPLAY_DELAY = 5000; // 5s

	let lastActiveIndex = 0;

	const homepageBanner = new Swiper('.index-banners__slider', {
		slidesPerView: 1,
		parallax: true,
		watchSlidesProgress: true,
		autoplay: {
			delay: AUTOPLAY_DELAY,
			disableOnInteraction: false,
		},

		pagination: {
			el: '.index-banners .swiper-pagination',
			clickable: true,
		},

		a11y: false,

		on: {
			init(swiper) {
				setTimeout(() => {
					swiper.slides.forEach((slide) => {
						slide.removeAttribute('role');
					});

					updateSlidesInert(swiper, 'active');
				}, 0);

				updateSwiperStatus(swiper);
				lastActiveIndex = swiper.snapIndex;
			},

			slideChange(swiper) {
				updateSwiperStatus(swiper);
				updateSlidesInert(swiper, 'active');

				if (swiper.autoplay && !swiper.autoplay.running) {
					const videos = swiper.el.querySelectorAll('video');
					videos.forEach((video) => video.pause());
				}

				const bullets = swiper.pagination.bullets;

				if (bullets[lastActiveIndex]) {
					bullets[lastActiveIndex].style.setProperty('--progress', 0);
				}

				lastActiveIndex = swiper.snapIndex;
			},

			autoplayTimeLeft(swiper, time, progress) {
				const bullets = swiper.pagination.bullets;
				const activeBullet = bullets[swiper.snapIndex];

				if (!activeBullet) return;

				activeBullet.style.setProperty('--progress', 1 - progress);
			},
		},
	});

	// кнопка Play / Pause
	const autoplayToggleBtn = document.querySelector('.index-banners__button');

	if (autoplayToggleBtn) {
		autoplayToggleBtn.addEventListener('click', () => {
			if (!homepageBanner.autoplay) return;

			const videos = homepageBanner.el.querySelectorAll('video');

			if (homepageBanner.autoplay.running) {
				homepageBanner.autoplay.stop();
				videos.forEach((video) => video.pause());
				autoplayToggleBtn.setAttribute('aria-label', Shopify.locale === 'uk' ? 'Відновити програвання': 'Возобновить воспроизведение')
				autoplayToggleBtn.classList.add('is-paused');
				let ariaLabel = autoplayToggleBtn.dataset.ariaPause;
				if (ariaLabel) {
					autoplayToggleBtn.setAttribute('aria-label', ariaLabel);
				}

			} else {
				homepageBanner.autoplay.start();
				videos.forEach((video) => video.play());
				autoplayToggleBtn.classList.remove('is-paused');
				let ariaLabel = autoplayToggleBtn.dataset.ariaPlay;
				if (ariaLabel) {
					autoplayToggleBtn.setAttribute('aria-label', ariaLabel);
				}
			}
		});
	}


	const twoColumn = new Swiper('.index-two-column__slider', {
		slidesPerView: 2,
		spaceBetween: 25,
		watchSlidesProgress: true,
		navigation: {
			nextEl: '.index-two-column__navigation--next',
			prevEl: '.index-two-column__navigation--prev',
		},

		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},

		breakpoints: {
			100: {
				slidesPerView: 1.1,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 25,
			},
		},

		a11y: false,

		on: {
			init(swiper) {
				setTimeout(() => {
					swiper.slides.forEach((slide) => {
						slide.removeAttribute('role');
					});

					updateSlidesInert(swiper, 'visible');
				}, 0);

				updateSwiperStatus(swiper);
			},

			slideChange(swiper) {
				updateSwiperStatus(swiper);
				updateSlidesInert(swiper, 'visible');
			},

			resize(swiper) {
				updateSwiperStatus(swiper);
				updateSlidesInert(swiper, 'visible');
			},
		},
	});
})